export const SHOWROOM_WORKER_BUILDING_GEN_QUERY_PARAM = "showroomWorkerBuildingGen";

export function parseShowroomWorkerBuildingGenOverride(search: string): boolean | undefined {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  if (!params.has(SHOWROOM_WORKER_BUILDING_GEN_QUERY_PARAM)) {
    return undefined;
  }

  const value = params.get(SHOWROOM_WORKER_BUILDING_GEN_QUERY_PARAM);
  if (value === null || value === "" || value === "true" || value === "1") {
    return true;
  }
  if (value === "false" || value === "0") {
    return false;
  }

  return undefined;
}
